import { DependencyList, useEffect } from "react";
import { useAppDispatch } from "../../framework/redux/hooks";
import { AsyncThunkAction } from "@reduxjs/toolkit";

export const useAsyncThunkAction = (
    action: () => AsyncThunkAction<void, any, any>,
    {
        onSuccess,
        onError,
    }: {
        onSuccess?: (value: void) => void | PromiseLike<void>;
        onError?: (reason: any) => void | PromiseLike<void>;
    },
    deps?: DependencyList
) => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        const dispatchAction = action();

        if (dispatchAction) {
            const promise = dispatch(dispatchAction);

            promise.unwrap().then(onSuccess).catch(onError);

            return () => {
                promise.abort();
            };
        }
    }, deps);
};
